import { useQuery } from '@tanstack/react-query'
import { v4prifix } from '../../app-config'
import xcpemSec from '../../axiosInstances/xcpemSec'
import { notifyError } from '../../components/Toaster'
import { commonCondition, earthlink, isEntryPoint, isScaling } from '../../lib/utils'
import { Customer } from '../../redux/GlobalSearch/types'

export const useGlobalSearch = (
  searchString: string
): {
  data: Customer[] | undefined
  isLoading: boolean
  error: any | null
  isFetching: boolean
  isFetched: boolean
  refetch: () => void
} => {
  const { data, isLoading, error, isFetching, isFetched, refetch } = useQuery(
    ['search-results'],
    async () => {
      if (searchString.length === 0) {
        return []
      }

      const commonFields = [
        `email.ilike.*${encodeURIComponent(searchString)}*`,
        `gw_uid.ilike.*${searchString}*`,
        `wan_mac.ilike.*${searchString}*`,
        `title.ilike.*${searchString}*`,
        `dev_serial.ilike.*${searchString}*`
      ]

      if (!commonCondition) {
        commonFields.push(`ott_serial.ilike.*${searchString}*`)
      }

      if (earthlink || process.env.REACT_APP_REALM === 'Scalingtests') {
        commonFields.push(`imei.ilike.*${searchString}*`)
      }

      if (isScaling || process.env.REACT_APP_REALM === 'entpnt') {
        commonFields.push(`account_customer_name.ilike.*${searchString}*`)
      }

      const query = commonFields.join(',')
      const endpoint =
        isEntryPoint || isScaling
          ? `${v4prifix}/dashboard_devices?offset=0&search=${encodeURIComponent(searchString)}`
          : `/webapp_dashboard_all_devices?offset=0&or=(${query})`

      try {
        const response = await xcpemSec.get<Customer[]>(endpoint)
        return response.data
      } catch (error: any) {
        notifyError(`Search: ${error?.response?.data?.message || error?.message}`)
      }
    },
    { keepPreviousData: true, staleTime: Infinity }
  )

  return { data, isLoading, error, isFetching, isFetched, refetch }
}
